// src/components/Header.jsx
import React, { useState } from "react";
import {
  AppBar, Toolbar, Typography, Box, IconButton, Drawer,
  List, ListItem, ListItemButton, ListItemText, Button
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

/* ✅ ΕΠΑΝΑΦΕΡΟΥΜΕ ΤΟ navLinks */
const navLinks = [
  { to: "/", labelKey: "home" },
  { to: "/services", labelKey: "services" },
  { to: "/portfolio", labelKey: "portfolio" },
  { to: "/blog", labelKey: "blog" },
  { to: "/about", labelKey: "about" },
  { to: "/contact", labelKey: "contact" }
];

const Header = ({ languages }) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [mobileOpen, setMobileOpen] = useState(false);

  const makePath = (path) => `/${lang || "en"}${path === "/" ? "" : path}`;

  return (
    <AppBar position="sticky" color="primary" sx={{ zIndex: 1201 }}>
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 0,
          width: "100%",
          px: { xs: 1, sm: 2 },
        }}
      >
        {/* Mobile: Hamburger */}
        <Box sx={{ display: { xs: "flex", md: "none" }, alignItems: "center" }}>
          <IconButton
            color="inherit"
            onClick={() => setMobileOpen(true)}
            aria-label="open menu"
          >
            <MenuIcon />
          </IconButton>
        </Box>

        {/* Logo with ellipsis */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            pr: { xs: 1, md: 2 },
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            component={Link}
            to={makePath("/")}
            sx={{
              color: "#fff",
              textDecoration: "none",
              letterSpacing: 1.5,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: { xs: "60vw", md: "unset" },
              fontSize: { xs: "1.05rem", sm: "1.2rem", md: "1.35rem" },
            }}
            title="BrainstormVisions"
          >
            BrainstormVisions
          </Typography>
        </Box>

        {/* Desktop nav */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1, alignItems: "center" }}>
          {navLinks.map((nav) => (
            <Button
              key={nav.labelKey}
              color="inherit"
              component={Link}
              to={makePath(nav.to)}
              sx={{
                fontWeight: "bold",
                textTransform: "none",
                letterSpacing: 1.1,
                fontSize: { md: "1rem" },
              }}
            >
              {t(nav.labelKey)}
            </Button>
          ))}
        </Box>

        {/* Language icon */}
        <Box sx={{ display: "flex", alignItems: "center", ml: { xs: 0, md: 1 } }}>
          <LanguageSwitcher languages={languages} />
        </Box>

        {/* Mobile drawer */}
        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            sx: {
              width: "85vw",
              maxWidth: 360,
              height: "100dvh",
              background: "#1e293b",
              color: "#fff",
            },
          }}
        >
          <Box sx={{ p: 2, position: "relative" }}>
            <IconButton
              color="inherit"
              onClick={() => setMobileOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
              aria-label="close menu"
            >
              <CloseIcon />
            </IconButton>

            <Box sx={{ mt: 1, display: "flex", justifyContent: "flex-end" }}>
              <LanguageSwitcher languages={languages} />
            </Box>

            <List sx={{ mt: 2 }}>
              {navLinks.map((nav) => (
                <ListItem key={nav.labelKey} disablePadding>
                  <ListItemButton
                    component={Link}
                    to={makePath(nav.to)}
                    onClick={() => setMobileOpen(false)}
                  >
                    <ListItemText
                      primary={t(nav.labelKey)}
                      primaryTypographyProps={{ fontWeight: "bold", fontSize: "1.08rem" }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
